export class GenerateStudentAccessModalData {
    public studentId: number;
    public studentName: string;
    public showWebsiteLinkButton: boolean;
    public showSignUpEmailButton: boolean;

    constructor() {}
}